// GENERATED from docs/design/tokens.json by docs/design/tools/tokens_to_css.py; do not edit.
export const GOOGLE_FONTS: string | null = "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Oswald:wght@500;600&display=swap";
export const FONT_THEMES: string[] = ["dark", "light", "shipwreck"];
